import { render, staticRenderFns } from "./CrmInsights.vue?vue&type=template&id=6fd25077&scoped=true"
import script from "./CrmInsights.vue?vue&type=script&lang=js"
export * from "./CrmInsights.vue?vue&type=script&lang=js"
import style0 from "./CrmInsights.vue?vue&type=style&index=0&id=6fd25077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd25077",
  null
  
)

export default component.exports